import React, { useState, useEffect, useRef, useField, Field } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function SubGoal() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [departmentsData, setDepartmentsData] = useState(null);
  const [options, setOptions] = useState([]);
  const [optionsSmart, setOptionsSmart] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [modifiedAssignees, setModifiedAssignees] = useState("");

  const [designation, setDesignation] = useState([]);
  const [smartgoalsdata, setSmartgoalsData] = useState([]);
  const [value, setValue] = useState([]);
  const [department, setDepartment] = useState([]);
  const [allemployees, setAllEmployees] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedEnddate, setSelectedEndDate] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [progress, setProgress] = useState("");
  const [teamMembers, setTeamMembers] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let smartgoalid = searchParams.get("id");
  smartgoalid = parseInt(smartgoalid);
  let deptid = searchParams.get("did");
  deptid = parseInt(deptid);
  const [employeeinitalsdata, setEmployeesInitialData] = useState([]);
  const [reporitnemployeesData, setReportingEmployeesData] = useState([]);
  const [isdeptselected, setIsDeptselected] = useState(false);
  const [isManager, setIsManager] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState(null);
  const [assigneevalues, setAssigneeValues] = useState(null);
  const [values, setValues] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const usernameRef = useRef(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getdepartments`
        );
        setOptions(response.data.departments);

        const role = localStorage.getItem("userrole");
        if (role === "ROLE_MANAGER" || role === "ROLE_SUPERVISOR") {
          setIsManager(true);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
    // fetchDesignations();
    fetchSmartgoals();
  }, []);
  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getallassigneesb`
        );
        setAllEmployees(response.data.employees);
        setEmployeesData(response.data.employees);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchAssignees();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let id = localStorage.getItem("employeeid");
        // let id = localStorage.getItem("supervisor");

        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        console.log(data)
        let arrTeamdata = data.team;
        setReportingEmployeesData(arrTeamdata);
        setEmployeesInitialData(arrTeamdata);
        // console.log(data);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchData();
  }, []);
  const fetchDesignations = async () => {
    try {
      let did = parseInt(searchParams.get("did"));
      if (did == "All") {
        did = 0;
      }
      const resp = await axios.get(
        `${baseURL}/getdeignationsfordept?did=` + did
      );
      if (resp.statusText === "OK") {
        setDesignationData(resp.data.designations);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const fetchSmartgoals = async () => {
    try {
      let did = searchParams.get("did");

      if (did === "All") {
        setDepartment(0);
        did = "0";
      } else {
        did = parseInt(did);
        setDepartment(did);
      }
      const resp = await axios.get(
        `${baseURL}/getsmartgoals?id=` + did
      );
      if (resp.statusText === "OK") {
        setSmartgoalsData(resp.data.smartgoals);

        getDates(resp.data.smartgoals);
      } else {
        console.error("smartgoals  fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const deisgnationChange = async (designationid) => {
    try {
      const currentSelectedOptions = selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [];
      let selecteddesignation = designationid;
      setDesignation(selecteddesignation);

      const resp = await axios.get(
        `${baseURL}/getassigneesbydesignationandept?id=` +
          designationid +
          "&did=" +
          deptid
      );
      if (resp.statusText === "OK") {
        const newEmployees = resp.data.employees;

        // Combine current selected options with new employees data, avoiding duplicates
        const combinedEmployees = [
          ...newEmployees,
          ...employeesData.filter((emp) =>
            currentSelectedOptions.includes(emp.id)
          ),
        ];

        // Remove duplicates based on 'id'
        const uniqueEmployees = Array.from(
          new Map(combinedEmployees.map((emp) => [emp.id, emp])).values()
        );

        setEmployeesData(uniqueEmployees);

        // Update the selected options to include new selections without duplicates
        const updatedSelectedOptions = [
          ...(selectedOptions || []),
          ...newEmployees.filter((emp) =>
            currentSelectedOptions.includes(emp.id)
          ),
        ];

        setSelectedOptions(updatedSelectedOptions);
        setEmployeesInitialData(uniqueEmployees);
        setAssigneeValues(
          uniqueEmployees.map((employee) => employee.id).join(",")
        );
        setIsDeptselected(true);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleChange = () => {};

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      // Perform form submission with the stored form data
      console.log("Submitting form:", formData);

      // Here you can perform an API call or save the form data using your preferred method
      // For example, you can use fetch to send the form data to a server
      const response = await axios.post(
        `${baseURL}/api/subgoal/create`,
        formData
      );

      if (response.status === 200) {
        // Reset form data and close modal after successful submission
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/goals");
        }, 3000);

        // Redirect to the desired page
        // window.location.href = "/goals"; // Update "/goals" with the desired URL
      } else {
        // Handle the case where the form submission fails
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const departmentChange = async (departmentid) => {
    try {
      //alert(designationid);
      let selectdepartment = departmentid;
      //alert("selected  designation"+selecteddesignation);
      setDepartment(departmentid);

      const resp = await axios.get(
        `${baseURL}/getsmartgoals?id=` + departmentid
      );
      if (resp.statusText === "OK") {
        //alert("after axios selected designation:"+designation);
        setSmartgoalsData(resp.data.smartgoals);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleRemoveAllOptions = () => {
    setAllEmployees([]);
  };
  const getDates = (smartgoalz) => {
    let startdate = "";
    let enddate = "";

    const smartgoal = smartgoalz.find((goal) => goal.id === smartgoalid);
    startdate = smartgoal.startdate;
    enddate = smartgoal.enddate;

    setStartDate(startdate);
    setEndDate(enddate);
  };

  const getValue = () => {

    let newopt = [];

    if (designation === "All" && deptid === "All") {

      newopt = employeeinitalsdata.map((employee) => ({
        value: employee.id,
        label: `${employee.FirstName} ${
          employee.LastName !== null ? employee.LastName : ""
        } - ${employee.employeeid}`,
      }));
    } else if (designation !== "All" && designation !== "0" && deptid === "All") {
     
      newopt = employeeinitalsdata.map((employee) => ({
        value: employee.id,
        label: `${employee.FirstName} ${
          employee.LastName !== null ? employee.LastName : ""
        } - ${employee.employeeid}`,
      }));
    }
    if (selectedOptions && selectedOptions.length > 0) {
      return selectedOptions;
    } else if (isdeptselected) {
      if (deptid !== "All") {
       
        newopt = employeeinitalsdata.map((employee) => ({
          value: employee.id,
          label: `${employee.FirstName} ${
            employee.LastName !== null ? employee.LastName : ""
          } - ${employee.employeeid}`,
        }));
      }
    } else {
      return [];
    }
    return newopt;
  };
  const handleSelectChange = (selected) => {
    setSelectedOptions(selected);
    let finalIds = selected.map((employee) => employee.value).join(",");
    setModifiedAssignees(finalIds);
  };
  // function getLastDayOfYear(date) {
  //   const year = date.getFullYear();
  //   const lastDay = new Date(year, 11, 31); // December is 11 in JavaScript
  //   return lastDay.toISOString().substr(0, 10);
  // }
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          title: "",
          startdate: "",
          enddate: "",
          description: "",
          departmentid: "",
          designationid: "",
          smartid: "",
          progress: "0",
          assignees: [],
        }}
        validationSchema={Yup.object({
          title: Yup.string().required("Title is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">ADD SUB KPI</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5">
                    <label>Department</label>
                    <select
                      className="form-select form-control"
                      name="departmentid"
                      disabled={isManager}
                    >
                      {options.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          selected={option.id === department}
                        >
                          {option.departmentname}
                        </option>
                      ))}
                    </select>
                    <input
                      type="hidden"
                      name="departmentid"
                      value={(values.departmentid = department)}
                    />
                  </div>
                  <div className="col-lg-5 ml-5">
                    <h5>
                      For This Smart Goal<span className="text-danger"></span>
                    </h5>
                    <select
                      disabled
                      className="form-select form-control"
                      name="smartid"
                    >
                      {smartgoalsdata &&
                        smartgoalsdata.map((goal) => (
                          <option
                            key={goal.id}
                            value={goal.id}
                            selected={goal.id === smartgoalid}
                          >
                            {goal.title}
                          </option>
                        ))}
                    </select>
                    <input
                      type="hidden"
                      name="smartid"
                      value={(values.smartid = smartgoalid)}
                    />
                  </div>
                  <h5 className="text-start pb-2 pt-3">SUB KPI</h5>
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Title <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.title && errors.title ? "is-invalid" : ""
                      }`}
                      placeholder="Enter title"
                      name="title"
                      onChange={(e) => setTitle(e.target.value)}
                      value={(values.title = title)}
                    />
                    {touched.title && errors.title ? (
                      <div className="text-danger">{errors.title}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5  ml-5">
                    <label>Start Date</label>
                    <br />
                    <input
                      type="date"
                      className="form-control"
                      name="startdate"
                      onChange={(e) => setSelectedDate(e.target.value)}
                      min={startDate}
                      max={endDate}
                      value={(values.startdate = selectedDate)} // Set default to current date
                    ></input>
                  </div>

                  <div className="col-lg-5 mt-2">
                    <label>Description</label>
                    <textarea
                      className={`form-control ${
                        touched.description && errors.description
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter description"
                      name="description"
                      onChange={(e) => setDescription(e.target.value)}
                      value={(values.description = description)}
                    ></textarea>
                    {touched.description && errors.description ? (
                      <div className="text-danger">{errors.description}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 mt-2 ml-5">
                    <label>End Date</label>
                    <br />
                    <input
                      type="date"
                      className="form-control"
                      name="enddate"
                      min={startDate}
                      max={endDate}
                      onChange={(e) => setSelectedEndDate(e.target.value)}
                      value={(values.enddate = selectedEnddate)}
                    ></input>
                  </div>

                  <div class="col-lg-5 mt-2">
                    <label>Progress (%)</label>
                    <br />
                    <input
                      type="number"
                      className="form-control"
                      min={0}
                      max={100}
                      name="progress"
                      onChange={(e) => {
                        const value = Math.min(parseInt(e.target.value), 100);
                        setProgress(value.toString());
                      }}
                      value={(values.progress = progress)}
                    />

                    <label style={{ display: "none" }}>
                      Select Designation
                    </label>
                    <input
                      type="hidden"
                      name="designationid"
                      value={designation}
                    />
                    <select
                      style={{ display: "none" }}
                      className="form-select form-control"
                      name="role"
                      placeholder="Select Designation"
                      value={values.role}
                      onChange={(e) => {
                        handleRemoveAllOptions();
                        deisgnationChange(e.target.value);
                      }}
                    >
                      <option valuue="">Select Designation</option>
                      {designationData.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* <div className="col-lg-5 mt-2 ml-5">
                    <label>Select Assignees <span className='text-danger'>*</span></label>
                    <Select
                      isMulti
                      name="assignees"
                      options={employeesData.map((employee) => ({
                        value: employee.id,
                        label: `${employee.FirstName} ${employee.LastName}`
                      }))}
                      value={values.assignees.map((id) => ({
                        value: id,
                        label: `${employeesData.find((emp) => emp.id === id)?.FirstName} ${employeesData.find((emp) => emp.id === id)?.LastName}`
                      }))}
                      onChange={(selectedOption) => {
                        const selectedValues = selectedOption ? selectedOption.map((option) => option.value) : [];
                        setFieldValue("assignees", selectedValues);
                      }}
                    />
                    {touched.assignees && errors.assignees ? <div className="text-danger">{errors.assignees}</div> : null}
                  </div> */}
                  <div className="col-lg-5 mt-2 ml-5">
                    <label>
                      Select Assignees <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable={true}
                      isMulti={true}
                      name="assignees2"
                      value={getValue()}
                      onChange={(selectedOptions) => {
                        // setAssigneevalues(selectedValues.join(","));
                        setSelectedOptions(selectedOptions);

                        let finalIds = selectedOptions
                          .map((employee) => employee.value)
                          .join(",");

                        setModifiedAssignees(finalIds);
                        setFieldValue("assignees", finalIds);
                        setFieldValue("assignees2", finalIds);
                        setIsDeptselected(false);
                        //  isassigneeselected(true);
                      }}
                      options={employeeinitalsdata.map((employee) => ({
                        value: employee.id,
                        label: `${employee.FirstName} ${
                          employee.LastName !== null ? employee.LastName : ""
                        } - ${employee.employeeid}`,
                      }))}
                    />

                    {touched.assignees && errors.assignees ? (
                      <div className="text-danger">{errors.assignees}</div>
                    ) : null}
                  </div>
                  <input
                    type="hidden"
                    name="assignees"
                    value={
                      (values.assignees = modifiedAssignees
                        ? modifiedAssignees
                        : employeeinitalsdata
                            .map((employee) => employee.id)
                            .join(","))
                    }
                  />
                  <input
                    type="hidden"
                    value={modifiedAssignees}
                    name="modifiedassignees"
                  ></input>
                  {/**
 employeeinitalsdata ? employeeinitalsdata.map((employee) => employee.id).join(",") : ''
*/}
                  {/* <div class="col-lg-5 mt-2 ">
                  <label>Progress (%)</label><br />
                  <input
                    type="number"
                    className='form-control'
                    min={0}
                    max={100}
                    name='progress'
                    onChange={(e) => setProgress(e.target.value)}
                    value={values.progress=progress} 
                        
                  ></input>
                </div> */}
                  <div className="col-lg-5 mt-2"></div>
                </div>
                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="/goals">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you Confirm this Changes</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default SubGoal;
